import { render, staticRenderFns } from "./merchant-app-list.vue?vue&type=template&id=76c07b4b&scoped=true"
import script from "./merchant-app-list.vue?vue&type=script&lang=js"
export * from "./merchant-app-list.vue?vue&type=script&lang=js"
import style0 from "./merchant-app-list.vue?vue&type=style&index=0&id=76c07b4b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c07b4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76c07b4b')) {
      api.createRecord('76c07b4b', component.options)
    } else {
      api.reload('76c07b4b', component.options)
    }
    module.hot.accept("./merchant-app-list.vue?vue&type=template&id=76c07b4b&scoped=true", function () {
      api.rerender('76c07b4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/develop-manage/merchant-app-list.vue"
export default component.exports